import React from 'react';
import Achivementscar from './Achivementscar';

function Achivements ()  {
  return (
    <div  className='about-div-threee'>
            <div className='about-div-one-heading vhfj'>
                <h1>| Achivements |</h1>
        </div>
        <div className='btm-car-wrapper'>
            <Achivementscar/>


        {/* <div className='btm-car'>
            <div className='btm-car-img'>
                <img src='hackforbengal.jpg' alt='_blank'/>
            </div>
            <div className='btm-car-txt'>
                <p> Hack4bengal(Hackathon 2023) </p>
            </div>

        </div> */}
        </div>
    </div>
  );
}

export default Achivements;
